import { createSelector } from 'reselect';

const selectWebsites = (state: any) => state.websites;


export const selectWebsitesCurrentItem = createSelector([selectWebsites], (websites) => websites.current);

export const selectWebsitesListItems = createSelector([selectWebsites], (websites) => websites.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectWebsitesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectWebsitesQueryItems = createSelector([selectWebsites], (websites) => websites.query);

export const selectWebsitesCreatedItem = createSelector([selectWebsites], (websites) => websites.create);

export const selectWebsitesUpdatedItem = createSelector([selectWebsites], (websites) => websites.update);

export const selectWebsitesReadItem = createSelector([selectWebsites], (websites) => websites.read);

export const selectWebsitesDeletedItem = createSelector([selectWebsites], (websites) => websites.delete);

export const selectWebsitesSearchedItems = createSelector([selectWebsites], (websites) => websites.search);

export const selectWebsitesItemsCount = createSelector([selectWebsites], (websites) => websites.count);

export const selectWebsitesItemsFilter = createSelector([selectWebsites], (websites) => websites.filter);